import ProfilePicture from "@/components/common/profile-picture";
import VerifiedBadgeCheck from "@/components/common/verified-badge-check";
import { formatImageUrl } from "@/lib/utils";
import { useModal } from "@/providers/modal-provider";
import { ModalType } from "@/types/modal-type";
import { TGetComments } from "@/types/comments";
import { formatDistance } from "date-fns";
import Link from "next/link";

const Comments = ({ comments }: { comments?: TGetComments }) => {
	const { closeModal } = useModal();
	const formattedComments = comments?.map((comment) => ({
		...comment,
		user: { ...comment.user, image: formatImageUrl(comment.user.image) },
	}));

	return (
		<section id="comments">
			{formattedComments?.map((comment) => (
				<div key={comment.id} className="mb-10">
					<div className="mb-3 flex items-start justify-between">
						<div className="flex items-center justify-start gap-3">
							<ProfilePicture
								profilePictureUrl={comment.user.image}
								alternateText={comment.user.name}
								className={{
									container: "h-10 w-10 rounded-full p-0.5",
									image: "rounded-full text-gray-600",
									badgeImage: "-bottom-3 h-7 w-7",
								}}
								isVerified={comment.user.UserProfile?.isVerified}
								isFounder={comment.user.UserProfile?.isFounder}
								isAmbassador={
									comment.user?.CategoryLeader && comment.user?.CategoryLeader?.length > 0
								}
							/>

							<div>
								<div className="flex items-center gap-2">
									<Link
										href={
											comment?.user?.UserProfile?.username
												? `/${comment?.user?.UserProfile?.username}`
												: `#`
										}
										onClick={() => closeModal(ModalType.ProductDetails)}
										className="font-bold capitalize text-dark-primary md:text-lg"
									>
										{comment?.user?.name}
									</Link>

									{/* a user is a verified founder / a founder associated with a proudct launch gets badge */}
									{((comment.user?.UserProfile?.isFounder &&
										comment.user?.UserProfile?.isVerified) ||
										comment.user?.Founder) && <VerifiedBadgeCheck iconClassName="w-5 h-5" />}
								</div>
								<h6 className="text-sm font-medium text-gray-400">
									{comment.user?.Founder?.role
										? comment.user.Founder.role
										: comment.user.UserProfile?.jobTitle
										? comment.user.UserProfile?.jobTitle
										: comment.user.UserProfile?.howDoYouIdentifyYourself}
									{comment.user?.UserProfile?.company
										? `, ${comment.user?.UserProfile?.company}`
										: ""}
								</h6>
							</div>
						</div>

						<span className="text-sm text-dark-secondary md:text-base">
							{formatDistance(new Date(comment?.createdAt), new Date())}
						</span>
					</div>

					<div className="rounded-md border border-form-field bg-brand-primary/[0.01] p-3 shadow-comment-box">
						<div
							className="whitespace-pre-wrap text-gray-700"
							dangerouslySetInnerHTML={{ __html: comment.commentText }}
						/>
					</div>
				</div>
			))}
		</section>
	);
};

export default Comments;
